// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html{-ms-overflow-style:none;scrollbar-width:none}html::-webkit-scrollbar{display:none}html{overflow:hidden;width:100vw;height:100vh;background-color:#404040}", ""]);
// Exports
module.exports = exports;
